export default function minifyCSSString(style) {
  return style.replace(/\s{2,}/g, '');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-named-media-query/node_modules/fela-utils/es/minifyCSSString.js
// module id = 49
// module chunks = 0